import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useInterviews from './useInterviews';

const useSingleInterview = () => {
  const { id: routeId } = useParams();
  const { singleItem, loading } = useInterviews(false, false);

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  return {
    singleItem: viewItem,
    loading,
  };
};

export default useSingleInterview;
